import React from 'react';

const Categories = () => (
  <button type="button">Check Status</button>
);

export default Categories;
